module.exports = __webpack_public_path__ + "img/portfolio-door_off.4795bcb4.png";